@use 'src/globals/main';

pn-choice-chip {
  display: inline-block;
}

pn-choice-chip .pn-choice-chip {
  position: relative;
  font-size: 1em;
  font-weight: 500;
  text-align: center;

  &-container {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    gap: 0;
    padding: 0.5em 1em;
    border: main.$input-border;
    border-radius: 0.5em;
    background-color: main.$input-background;
    @include main.pn-transition('border-color, outline-color, background-color, padding, gap');
    @include main.pn-focus-base;

    &[data-icon] {
      gap: 0.25em;
      padding-left: 0.75em;
      &[data-small] {
        padding-left: 0.5em;
      }
      &[data-large] {
        padding-left: 1em;
      }
      > .pn-choice-chip-icon {
        width: 1.5em;
      }
    }

    &[data-small] {
      padding: 0.25em 0.75em;
      .pn-choice-chip-label {
        line-height: 1.25em;
        > span {
          font-size: 0.875em;
        }
      }
    }

    &[data-large] {
      padding: 0.625em 1.25em;
    }
  }

  &-icon {
    position: relative;
    width: 0;
    height: 1.5em;
    @include main.pn-transition('width');
    pn-icon {
      opacity: 0;
      transform: scale(0);
      position: absolute;
      top: 0;
      left: 0;
      @include main.pn-transition('transform, opacity');

      &.pn-choice-chip-icon-user {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  &-label {
    color: main.$input-chip-color;
    line-height: 1.5em;
    @include main.pn-transition('color');
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-grow: 1;
    height: 100%;
  }

  > input {
    position: absolute;
    z-index: 1;
    opacity: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;

    &:not(:checked) ~ .pn-choice-chip-container > .pn-choice-chip-icon > .pn-choice-chip-icon-user {
      transform: scale(1);
      opacity: 1;
    }

    &:hover ~ .pn-choice-chip-container {
      background-color: main.$blue25;
      border-color: main.$blue700;

      .pn-choice-chip-icon {
        &-user,
        &-check {
          .pn-icon-svg path {
            fill: main.$blue700;
          }
        }
      }

      .pn-choice-chip-label {
        color: main.$blue700;
      }
    }

    &:checked {
      ~ .pn-choice-chip-container {
        gap: 0.25em;
        background-color: main.$blue50;
        border-color: main.$border-color-default-active;
        > .pn-choice-chip-icon {
          width: 1.5em;
          stroke-dashoffset: 23;

          > .pn-choice-chip-icon-check {
            transform: scale(1);
            opacity: 1;
          }
          > .pn-choice-chip-icon-user {
            transform: scale(0);
            opacity: 0;
          }
        }
        > .pn-choice-chip-label {
          color: main.$input-chip-color-active;
        }
      }
      &:hover ~ .pn-choice-chip-container {
        background-color: main.$blue25;
        border-color: main.$input-button-active-hover;
        > .pn-choice-chip-icon > .pn-choice-chip-icon-check path {
          fill: main.$input-button-active;
        }
        > .pn-choice-chip-label {
          color: main.$input-button-active;
        }
      }
    }

    &:focus-visible ~ .pn-choice-chip-container {
      @include main.pn-focus-visible(main.$border-color-default-active);
      border-color: main.$border-color-default-active;
    }

    &:disabled {
      cursor: not-allowed;
      &:active ~ .pn-choice-chip-container {
        outline: none;
      }
      ~ .pn-choice-chip-container {
        background-color: main.$input-background-disabled;
        border-color: main.$border-color-disabled;
        cursor: not-allowed;
        .pn-choice-chip-label {
          color: main.$input-color-disabled;
          cursor: not-allowed;
        }
        pn-icon .pn-icon-svg path {
          fill: main.$input-color-disabled;
        }
      }
    }
  }
}
